import Marquee from "react-fast-marquee";

const ITEMS = ["TOP-DOLLAR PRICING", "VISIBLE SCALES", "FAMILY OWNED"];

export const TrustMarquee = () => (
  <div className="bg-zinc-950 border-y-4 border-red-700 py-4" data-testid="trust-marquee">
    <Marquee speed={35} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-heading text-white text-lg sm:text-xl tracking-[0.15em] px-6">{item}</span>
          <span className="text-red-600 text-xl font-heading">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
